import { setStore, getStore, removeStore } from '@/util/store'
import { defineStore } from 'pinia'
import { validateNull } from '@/util/validate'
import { getUserLastType } from '@/api/user.js'
import { router } from '@/router'
const useUserStore = defineStore('userStore', {
  state: () => {
    return {
      accountInfo: getStore({ name: 'accessInfo' }) || {},
      userInfo: getStore({ name: 'userInfo' }) || {},
      token: getStore({ name: 'access_token' }) || '', //当前的token值
      currentRole: getStore({ name: 'currentRole' }), // 当前角色
      appAliasUrl: '', // 获取当前应用别名
      dataViewSchoolId: '', //学校id
    }
  },
  actions: {
    getAccountInfo(accountInfo) {
      this.accountInfo = accountInfo
      setStore({ name: 'accessInfo', content: this.accountInfo })
      const { memberType } = accountInfo
      /**
       * 1. 如果没有角色，则跳转无权限页面
       */
      if (validateNull(memberType)) {
        router.push('/noPermission')
      } else {
        this.getCurrentRole(accountInfo.user_id)
      }
    },
    async getUserData(userInfo) {
      this.userInfo = userInfo
      setStore({ name: 'userInfo', content: this.userInfo })
    },
    //设置token
    setAccessToken(token) {
      this.token = token
      setStore({ name: 'access_token', content: token })
    },
    //设置当前角色
    setCurrentRole(role) {
      const redirectConfig = {
        manager: '/admin',
        teacher: '/home',
        student: '/student',
      }
      this.currentRole = role || 'manager'
      setStore({ name: 'currentRole', content: role })
      router.replace(redirectConfig[this.currentRole])
    },
    /**
     * 获取当前用户的角色
     */
    async getCurrentRole(userId) {
      if (validateNull(userId)) return
      if (validateNull(this.currentRole)) {
        const res = await getUserLastType(userId)
        const { code, data } = res.data
        if (code === 0) {
          const identity = data[0]
          if (!window.JSAndroid) {
            // 非安卓端才设置角色
            this.setCurrentRole(identity)
          }
        }
      } else {
        // 第一次登录，设置默认角色
        if (!window.JSAndroid) {
          // 非安卓端才设置角色
          const memberType = this.accountInfo?.memberType || this.userInfo?.memberType
          const currentRole = this.getDefaultRole(memberType)
          this.setCurrentRole(currentRole)
        }
      }
    },
    getDefaultRole(roles) {
      // 管理员、教师、学生优先级
      const rolesPriority = {
        manager: 3,
        teacher: 2,
        student: 1,
      }

      const sortedRoles = roles
        .filter((role) => rolesPriority[role])
        .sort((a, b) => rolesPriority[b] - rolesPriority[a])

      return sortedRoles.length > 0 ? sortedRoles[0] : null
    },
    //删除token
    removeStore() {
      this.token = ''
      removeStore({
        name: 'access_token',
      })
    },
    setDataViewSchoolId(id) {
      this.dataViewSchoolId = id
    },
  },
})

export default useUserStore
